export default __webpack_public_path__ + "static/media/5b8da7beb0888841.958aa8a995865f01fb72df10804a8cc1.svg";